<template>
  <div class="audio_preview_wrap">
    <div class="audio_preview_box">
      <div class="audio_head">
        <p class="audio_name">{{audioName}}</p>
        <span class="el-icon-circle-close close_btn" @click="closeFn()"></span>
      </div>
      <div class="imgbg">
        <img src="../../../../../../static/images/newCourse/audioBg.png">
      </div>
      <div class="video_wrap">
        <audio  ref='audio' :src="audioSrc" controls="controls" autoplay="autoplay" ></audio>
      </div>
    </div>
  </div>
</template>
<script>
    export default {
        props: ['audioName', 'audioSrc'],

        methods: {
            closeFn(){
                this.$emit('closeFn')
            }
        }
    }
</script>
<style lang="scss" scoped>
  .audio_preview_wrap{
    width: 100%;
    height: 100%;
    position: fixed;
    left: 0;
    top: 0;
    background: rgba($color: #000000, $alpha: 0.6);
    z-index: 2000;
    .audio_preview_box{
      width: 960px;
      height: 540px;
      position: absolute;
      left: 0;
      top: 0;
      right: 0;
      bottom: 0;
      margin: auto;
      background: rgba(0,0,0,0.6);
      .audio_head{
        width: 960px;
        height: 32px;
        background: rgba(0, 0, 0, 0.6);
        position: absolute;
        top: 0;
        left: 0;
        display: flex;
        justify-content: space-between;
        align-items: center;
        z-index: 10;
        .audio_name{
          width: 600px;
          font-size: 12px;
          font-weight: 500;
          color: #FFFFFF;
          line-height: 32px;
          margin-left: 20px;
        }
        .close_btn{
          color: #ffffff;
          font-size: 20px;
          margin-right: 10px;
          cursor: pointer;
        }
      }
      .imgbg{
        img{
          width: 910px;
          height: 540px;
        }
      }
      .video_wrap{
        position: absolute;
        top: 50%;
        left: 30%;
        transform: translateY(-50%);;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/szrt_revision/new_course_module/editCourse/sourceMaterial/audioView.vue